import { Button, Grid, Typography } from "@mui/material";

export default function Prepare() {
  return (
    <Grid item xs={12} mt={4} px={3} pt={3} sx={{ bgcolor: "#EEFCFB" }}>
      <Typography variant="body1" fontWeight="bold">
        1. Prepare your Professional Portfolio
      </Typography>

      <ul>
        <li>
          <Typography variant="body1">
          Make sure you have completed all sections of your professional portfolio 
          using your CDA Professional Portfolio checklist.
          </Typography>
        </li>
      </ul>
    </Grid>
  );
}
